<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('create','discount.codes')"
            variant="success"
            @click="createButtonClicked"
          >
            {{ $t('Create discount code') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <discount-codes-list
      v-else
      :fields="fields"
      :items="items"
      :additional-data="additionalData"
      @onDeleteButtonClicked="deleteButtonClicked"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../../common/mixins/list'
import DiscountCodesList from '../../../components/admin/discount-codes/list/DiscountCodesList'

export default {
  components: {
    DiscountCodesList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'discount-codes',
      adminFields: [
        {
          key: 'id',
          label: this.$t('Id'),
        },
        {
          key: 'code',
          label: this.$t('Code'),
        },
        {
          key: 'amount',
          label: this.$t('Amount'),
        },
        {
          key: 'display_amount_type',
          label: this.$t('Type'),
        },
        {
          key: 'usages',
          label: this.$t('Usages'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'expire_at',
          label: this.$t('Expire at'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
